import React from "react";
import ClientForm from "./form/ClientForm";
import { getUserIdTokenForIonTime, setCookieData } from "../../../helper/api";
import { useManageClientContext } from "../../../context/ManageClientContex";
import ClientProject from "./ClientProject";
import { useLocation } from "react-router-dom";
import { useLoading } from "../../../context/LoadingContext";

const TabNames: string[] = ["Update Client", "Manage Project"];

const UpdateClientPage: React.FC = () => {
  const [activeTab, setActiveTab] = React.useState<string>("Update Client");
  const { isLoading } = useLoading();
  const location = useLocation();
  const getUserId = getUserIdTokenForIonTime();
  const { setClientID, getClientDetails } = useManageClientContext();
  
  const state = location.state as { id: number } | undefined; // Assuming state is an object with an 'id' property
  // Access 'id' from state if it exists
  const clientIdData = state?.id;

  React.useEffect(() => {
    setCookieData('clientProject', '0');
    if (getUserId && clientIdData) {
      setClientID(clientIdData)
      getClientDetails({
        user_id: Number(getUserId),
        client_id: clientIdData,
        status: Number(0),
      });
    }
  }, [getUserId, clientIdData, getClientDetails, setClientID]);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  const handleTabClick = (tab: string) => {
    setActiveTab(tab);
  };

  return (
    <div>
      <div className='mb-4 border-b border-gray-200 dark:border-gray-700'>
        <ul
          className='flex flex-wrap -mb-px text-sm font-medium text-center'
          id='default-tab'
          data-tabs-toggle='#default-tab-content'
          role='tablist'
        >
          {TabNames.map((item) => (
            <li key={item} className='me-2' role='presentation'>
              <button
                className={`inline-block p-4 border-b-2 rounded-t-lg ${
                  activeTab === item ? "border-blue-600 text-blue-600" : "dark:border-gray-600"
                }`}
                id={item + `-tab`}
                data-tabs-target={`#` + item}
                type='button'
                role='tab'
                aria-controls={item}
                aria-selected={activeTab === item}
                onClick={() => handleTabClick(item)}
              >
                {item}
              </button>
            </li>
          ))}
        </ul>
      </div>
      <div id='default-tab-content'>
        {TabNames.map((item) => (
          <div
            key={item}
            className={`p-4 rounded-lg bg-white dark:bg-gray-800 ${activeTab === item ? "block" : "hidden"}`}
            id={item}
            role='tabpanel'
            aria-labelledby={item + "-tab"}
          >
            {activeTab === "Update Client" && <ClientForm />}
            {activeTab === "Manage Project" && <ClientProject clientID={Number(clientIdData)} userID={Number(getUserId)}/>}
          </div>
        ))}
      </div>
    </div>
  );
};

export default UpdateClientPage;
